export enum OrderSlotsShowEnum {
  FirstDaySelected = 'FIRST_DAY_SELECTED',
  FirstDayMonthOrWeek = 'FIRST_DAY_MONTH_OR_WEEK',
}
